import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { BookOpen } from 'lucide-react'
import { DocsScreen } from '@/screens/develop/SCR-058-docs'

export const Route = createFileRoute('/_app/develop/docs')({
  staticData: {
    screen: { id: 'SCR-058', title: 'Developer docs', group: 'Develop', order: 3, description: 'Connect an agent, call the memory API over REST or MCP, and handle errors, limits and retries.', icon: BookOpen },
  },
  validateSearch: z.object({ q: z.string().max(100).optional() }),
  component: DocsScreen,
})
